export type MediaLinkModel = {
  cache_key: number,
  id: number,
  label?: string,
  link_type: string,
  linkable_id: number,
  linkable_type: string,
  url: string,
}

export type MediaLinkRequestOptions = {}

const state = {
  id: null,
  label: '',
  link_type: '',
  linkable_id: undefined,
  linkable_type: '',
  url: '',
}

export const requiredFields = [
  { key: 'linkable_type' },
  { key: 'link_type' },
  { key: 'url' },
]

export default state
